import { I18n } from "i18n-js";
import translations from "../../../../locales.json";

const i18n = new I18n(translations);
i18n.defaultLocale = "es";
i18n.locale = "es";

const HTML_INPUT_TYPES = [
  // "button",
  // "checkbox",
  "color",
  "date",
  "datetime",
  "email",
  // "file",
  // "hidden",
  "image",
  "month",
  "number",
  "password",
  // "radio",
  "range",
  // "reset",
  // "search",
  // "submit",
  // "tel",
  "text",
  "time",
  "url",
  "week",
]

export const KARIN_LAW_DEFAULT_GROUP_NAME = [
  i18n.t('karin_law.workflow.requirements.form.victim.title'),
  i18n.t('karin_law.workflow.requirements.form.representative.title'),
  i18n.t('karin_law.workflow.requirements.form.perpetrator.title'),
]

export const ECONOMIC_CRIME_DEFAULT_GROUP_NAME = [
  i18n.t('economic_crime.workflow.requirements.form.informer.title')
]

// ---------- START FIELD ITEM ----------
export const fieldItemIsRequired = fieldItem => {
  return fieldItem.is_required || false
}

export const fieldItemHtmlInputType = fieldItem => {
  if (_.includes(HTML_INPUT_TYPES, fieldItem.data_type)) {
    return fieldItem.data_type;
  } else {
    return 'text'
  }
}
// ---------- END FIELD ITEM ----------

// ---------- START FILE ITEM ----------
export const fileItemIsRequired = fileItem => {
  return fileItem.is_required || false;
}
// ---------- END FILE ITEM ----------

export const nextStages = requirementStage => {
  return _.sortBy(requirementStage.next_stages, 'name')
}

export const returnStages = requirementStage => {
  return _.sortBy(requirementStage.return_stages, 'name')
}

export const isInputStage = requirementStage => {
  return requirementStage.node_type == 'input'
}

export const isDefaultStage = requirementStage => {
  return requirementStage.node_type == 'default'
}

export const isOutputStage = requirementStage => {
  return requirementStage.node_type == 'output'
}

export const isShortlistStage = requirementStage => {
  return requirementStage.node_type == 'shortlist'
}
